import { Entry, EntryCollection } from 'contentful';
import IClientLogo from '@app/types/base/IClientLogo';
import ContentfulService from './base/ContentfulService';

export default class ClientLogoService extends ContentfulService {
	public async getLogos(): Promise<IClientLogo[]> {
		const logos: EntryCollection<any> = await this.deliveryClient.getEntries({
			// eslint-disable-next-line @typescript-eslint/naming-convention
			content_type: 'clientLogo'
		});

		return logos.items.map(
			(logo: Entry<any>): IClientLogo => ({
				id: logo.sys.id,
				title: logo.fields.title as string,
				svg: logo.fields.svg as string
			})
		);
	}
}
